import { NgModule } from '@angular/core';
import {
  provideRouter,
  RouterModule,
  Routes,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';
import { AuthGuard } from './guards';
import { selectedOrganizationResolver } from './resolvers/selected-organization.resolver';
import { SigninGuard } from './guards/signin.guard';
import { LogoutComponent } from './modules/logout/logout.component';
import { AuthInitializationGuard } from './guards/auth-initialize.guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.routes'),
    canActivate: [AuthInitializationGuard, AuthGuard],
    data: { role: 'admin' },
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'onboard',
    loadChildren: () =>
      import('./modules/property-onboard/onboard.module').then(
        (m) => m.OnboardModuleWithRouting,
      ),
    canActivate: [AuthInitializationGuard, AuthGuard],
    resolve: {
      organizationId: selectedOrganizationResolver,
    },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'signin',
    canActivate: [AuthInitializationGuard, SigninGuard],
    runGuardsAndResolvers: 'always',

    loadChildren: () => import('./modules/signin/signin.routes'),
  },
  {
    path: 'logout',
    loadComponent: () => LogoutComponent,
  },
  {
    path: 'simulator',
    loadChildren: () =>
      import('./modules/simulator/simulator.module').then(
        (m) => m.SimulatorModule,
      ),
    canActivate: [AuthInitializationGuard, AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'invitation',
    loadChildren: () => import('./modules/invitation/invitation.routes'),
  },
  {
    path: '',
    canActivate: [AuthInitializationGuard, AuthGuard],
    resolve: {
      organizationId: selectedOrganizationResolver,
    },

    loadChildren: () =>
      import('./modules/user-container/user-container.module').then(
        (m) => m.UserContainerModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
  ],
})
export class AppRoutingModule {}
